export default {
  /* 新随身打模板分类 */
  saveClassifyapi: '/printApi/print/api/classify/saveClassify',
  /* 根据父级分类查询所有子分类 */
  queryprintClassifyByPidapi: '/printApi/print/api/classify/queryClassifyByPid',
  /* 分页查询*/
  queryprintClassifyPageapi: '/printApi/print/api/classify/queryClassifyPage',
  /* 查询所有二级子分类*/
  queryClassifyByChildapi: '/printApi/print/api/classify/queryClassifyByChild',
  /* 修改主题分类*/
  updatePrintClassifyapi: '/printApi/print/api/classify/updateClassify',
  /* 新增素材接口*/
  sevaMaterialapi: '/printApi/print/api/material/sevaMaterial',

  queryMaterialByIDapi: '/printApi/print/api/material/queryMaterialByID',
  /* 查询素材接口列表*/
  queryMaterialPageapi: '/printApi/print/api/material/queryMaterialPage',
  /* 编辑素材信息*/
  editMaterialapi: '/printApi/print/api/material/editMaterial',
  /* 新增反馈分类信息*/
  saveFeedbakTypesapi: '/printApi/print/api/feedbakTypes/saveFeedbakTypes',
  /* 分页查询反馈分类信息*/
  queryFeedbakTypesPageapi: '/printApi/print/api/feedbakTypes/queryFeedbakTypesPage',
  /* 编辑反馈分类信息*/
  editFeedbakTypesapi: '/printApi/print/api/feedbakTypes/editFeedbakTypes',
  /* 新增教程视频信息*/
  saveDemoVideoapi: '/printApi/print/api/demoVideo/saveDemoVideo',
  /* 分页查询教程视频*/
  queryDemoVideoPageapi: '/printApi/print/api/demoVideo/queryDemoVideoPage',

  // 获取语言类型列表
  queryLanguageListApi: '/printApi/print/api/language/selectListPage',
  // 新增语言类型
  addLanguageApi: '/printApi/print/api/language/insert',
  // 编辑
  editLanguageApi: '/printApi/print/api/language/update',
  // 删除
  deleteByIdLanguageApi: '/printApi/print/api/language/deleteById',
  // 查询
  selectListLanguageApi: '/printApi/print/api/language/selectList',
  // 设置分类id
  setClassifyIdApi: '/printApi/print/api/classify/setClassifyId',


  // 未授权设备
  findPrintDeviceListPage: '/backstageApi/printDevice/findPrintDeviceListPage',
  printDeviceSave: '/backstageApi/printDevice/save'
}



// WEBPACK FOOTER //
// ./src/api/device/printer.js